import { render, staticRenderFns } from "./CusPaymentsModule.vue?vue&type=template&id=5bc873a8"
import script from "./CusPaymentsModule.vue?vue&type=script&lang=js"
export * from "./CusPaymentsModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports